import {combineReducers} from "redux";
import uploadApk from "./uploadApk";
import userConfig from "./userConfig";

const otherSettingReducer = combineReducers({
    uploadApk,
    userConfig
});

export default otherSettingReducer;